export const copyTextToBuffer = (textToCopy: string): void => {
  if (window.isSecureContext && navigator.clipboard) {
    // Probably this should be awaited actually, review while adding to that functional.
    void navigator.clipboard.writeText(textToCopy);
  }
};
